import ArrowsDown from '../ArrowsDown/ArrowsDown'

export const InnerContainer = ({ items, color, selectedItem, onClick }) => {
  return (
    <div className="inner-container">
      <ul className="index-list">
        {items?.map((item, index) => (
          <li className={`uppercase bold text-normal ${selectedItem === item.key ? 'selected' : ''}`} key={item.key} onClick={() => onClick(item)}>
            <span>
              {index + 1}. {item.title}
            </span>
            <div className="arrows-container">
              <ArrowsDown color={color} />
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
